import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

// Components
import Loader from '../utils/Loader'

// State
import { addRoute } from '../../store/actions/route'
import { setpageTitle, getNotices } from '../../store/actions/siteInfo'
import { userTokenUpdate } from '../../store/actions/user'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

class AdminNotices extends Component {
    constructor(props){
        super(props)

        this.state = {
            isLoading: true,
            data: {
                title: '',
                link: ''
            },
            error: '',
            updateLoading: false,
            updateSuccess: '',
            updateErrors: {}
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Notices')
    }

    componentDidMount() {
        this.loadData()
    }

    loadData(){
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }
        return axios.get(REACT_APP_API_URL + 'notices', { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({ isLoading: false, error: response.data.message })
            }else{
                this.setState({
                    isLoading: false,
                    data: {
                        ...response.data.notice,
                        link: response.data.notice.url ? response.data.notice.url : ''
                    }
                })
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
            }else{
                this.setState({ isLoading: false, error: err.message })
            }
		})
    }

    handleInputChange(event){
        event.preventDefault()
		this.setState({
			data: {
                ...this.state.data,
                [event.target.id]: event.target.value
            }
		})
    }

    handleKeyPress(event, item_id){
		if (event.key === 'Enter'){
			this.handleSubmit()
		}
    }

    handleSubmit(){
        const { data } = this.state
        const { user } = this.props

        this.setState({
            updateSuccess: '',
            updateErrors: {},
            updateLoading: true
        })

        const token = user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        return axios.post(REACT_APP_API_URL + 'notices/', data, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({
                    updateLoading: false,
                    updateErrors: !isEmpty(response.data.errors) ? response.data.errors : { general: response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateSuccess: response.data.message
                })

                this.props.userTokenUpdate('admin', response.data.token)
                this.props.getNotices()
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.message }
                })
            }
		})
    }

    render() {
        return (
            <div>
                <h1>Update Notices</h1>

                {/* Has error */}
                {this.state.error ? (
                    <div className="error">
                        {Object.keys(this.state.error).map(key => 
                            <span key={key}>{this.state.error[key]}</span>
                        )}
                    </div>
            
                // No error
                ) : (
                    
                    // Loading
                    this.state.isLoading ? (
                        <div className="pt2 pb2">
                            <Loader />
                        </div>
                    
                    // Show form
                    ) : (
                        <div>
                            {this.state.updateSuccess && <div className="success msg_animate">{this.state.updateSuccess}</div>}

                            <div className="form-field">
                                <label>Title:</label>
                                
                                {this.state.updateErrors.title &&
                                    <div className="error msg_animate">{this.state.updateErrors.title}</div>
                                }
                                <input type="text" id="title" value={this.state.data.title} maxLength="255"
                                    onKeyPress={e => this.handleKeyPress(e)}
                                    onChange={event => this.handleInputChange(event)}
                                />
                            </div>
                            
                            <div className="form-field">
                                <label>Link:</label>
                                
                                {this.state.updateErrors.link &&
                                    <div className="error msg_animate">{this.state.updateErrors.link}</div>
                                }
                                <input type="text" id="link" value={this.state.data.link} maxLength="255"
                                    onKeyPress={e => this.handleKeyPress(e)}
                                    onChange={event => this.handleInputChange(event)}
                                />
                            </div>

                            <div className="btn_container">
                                {this.state.updateErrors.general &&
                                    <div className="error msg_animate">{this.state.updateErrors.general}</div>
                                }
                                <button className={'btn submit-btn' + (this.state.updateLoading ? ' loading' : '')} onClick={() => this.handleSubmit()} disabled={this.state.updateLoading}><span>Submit</span></button>
                            </div>
                        </div>
                    )
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
	return {
		user: state.user.admin
	}
}

export default connect(mapStateToProps, { addRoute, userTokenUpdate, setpageTitle, getNotices })(AdminNotices)



// WEBPACK FOOTER //
// ./src/components/admin/AdminNotices.js